import { render } from "./LockedStakingBody.vue?vue&type=template&id=b56dd00c&scoped=true"
import script from "./LockedStakingBody.vue?vue&type=script&lang=js"
export * from "./LockedStakingBody.vue?vue&type=script&lang=js"

import "./LockedStakingBody.vue?vue&type=style&index=0&id=b56dd00c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56dd00c"]])

export default __exports__